import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { TmxFetchResponse } from "../components/Common/Sync/useConnectorSync";

const useFetchTransportsFromTmx = (siteId: string, options?: RequestOptions<TmxFetchResponse>) => {
  const business = useSelectedBusiness();
  return useUserRequest<void, TmxFetchResponse>({
    path: `/api/businesses/${business.id}/transports/sync/fetch?siteId=${siteId}`,
    method: HttpMethod.POST,
  }, options);
}

export default useFetchTransportsFromTmx;
